export default __webpack_public_path__ + "static/characters03-f6bde7d9907a3f060a8f9204054c4262.png";